import { useMemo } from 'react';
import EnquiryForm, { type EnquiryTypeOption } from './EnquiryForm';

interface TradeEnquiryFormProps {
  resourceType: string;
  resourceId: number;
  tradeHubSettings: any;
  onSuccess?: () => void;
  className?: string;
}

export default function TradeEnquiryForm({
  resourceType,
  resourceId,
  tradeHubSettings,
  onSuccess,
  className,
}: TradeEnquiryFormProps) {
  const enquiryTypes: EnquiryTypeOption[] = useMemo(
    () => [
      { value: 'general', label: 'General Enquiry', enabled: true },
      {
        value: 'sample_request',
        label: 'Sample Request',
        enabled: tradeHubSettings?.sampleRequestsEnabled,
      },
    ],
    [tradeHubSettings]
  );

  return (
    <EnquiryForm
      modalSignup
      sessionRequiredToSubmit
      showSubject={false}
      showType
      context="trade-enquiry"
      apiRoute="entities/enquiries"
      resourceType={resourceType}
      resourceId={resourceId}
      enquiryTypes={enquiryTypes}
      onSuccess={onSuccess}
      className={className}
    />
  );
}
